import * as React from "react"
import styled from "styled-components"
import { Line, isRentalDataPlanVariant, isRentalTerminalVariant } from "../../interfaces/SaleorTypes"
import BodyMedium from "../../atoms/typography/BodyMedium"
import { RENTAL_INITIAL_COST_SLUG, RENTAL_MONTHLY_COST_SLUG } from "../../../utils/saleor-constants"
import RentalPriceBreakdown from "../../molecules/store/RentalMolecules/RentalPriceBreakdown"

interface ConfirmationItemCardProps {
  lines: Line[]
  selectedDate: string
}

const SubHeaderWrapper = styled.div`
  margin-bottom: 0.4em;
`

const Divider = styled.div`
  border: solid 1px #898989;
`

const ConfirmationContainer = styled.div`
  width: 100%;
  margin-top: 1em;
`

const ConfirmationTerminalSection: React.FunctionComponent<ConfirmationItemCardProps> = ({ lines, selectedDate }) => {
  const rentalTerminalLine = lines.find(
    (line) => isRentalTerminalVariant(line.variant) && line.variant.rentalVariantSlug === RENTAL_INITIAL_COST_SLUG,
  )
  const rentalMonthsLine = lines.find(
    (line) => isRentalTerminalVariant(line.variant) && line.variant.rentalVariantSlug === RENTAL_MONTHLY_COST_SLUG,
  )
  const rentalDataPlanLine = lines.find((line) => isRentalDataPlanVariant(line.variant))

  const [numberOfMonths, setNumberOfMonths] = React.useState<number | undefined>(undefined)

  React.useEffect(() => {
    if (rentalTerminalLine && rentalMonthsLine && rentalDataPlanLine) {
      setNumberOfMonths(Math.floor(rentalMonthsLine.quantity / rentalTerminalLine.quantity))
    }
  }, [rentalTerminalLine, rentalMonthsLine, rentalDataPlanLine])

  const checkIfCategoryExists = () => {
    let flag = false
    lines.map((item: Line) => {
      if (item?.variant?.product?.category?.name == "Rentals") {
        flag = true
      }
    })
    return flag
  }

  return (
    <div>
      {lines && lines.length > 0 && checkIfCategoryExists() && (
        <div>
          <SubHeaderWrapper>
            <BodyMedium>Satcube Instant Package</BodyMedium>
          </SubHeaderWrapper>
          <Divider />
          <ConfirmationContainer>
            {rentalTerminalLine && rentalMonthsLine && rentalDataPlanLine && numberOfMonths && (
              <RentalPriceBreakdown
                amountOfRentals={rentalTerminalLine.quantity}
                rentalTerminalInitialFeePrice={rentalTerminalLine.variant.pricing.price.gross.amount}
                currency={rentalTerminalLine.variant.pricing.price.currency}
                numberOfMonths={numberOfMonths}
                rentalMonthlyFeePrice={rentalMonthsLine.variant.pricing.price.gross.amount}
                chosenDataPackage={rentalDataPlanLine.variant}
                chosenDataPackagePrice={rentalDataPlanLine.variant.pricing.price.gross.amount}
                selectedDate={selectedDate}
                subTotal={
                  rentalTerminalLine.variant.pricing.price.gross.amount +
                  rentalMonthsLine.variant.pricing.price.gross.amount * numberOfMonths +
                  rentalDataPlanLine.variant.pricing.price.gross.amount
                }
              />
            )}
          </ConfirmationContainer>
        </div>
      )}
    </div>
  )
}

export default ConfirmationTerminalSection
